import {
  FormControl,
  FormHelperText,
  OutlinedInput,
  TextField,
} from "@mui/material";
import { useState } from "react";
import { Controller } from "react-hook-form";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: relative;
  max-width: ${({ mwidth }) => mwidth};
  @media only screen and (max-width: 768px) {
    max-width: 100% !important;
  }
`;

const StyledLabel = styled.label`
  font-weight: 700;
  color: var(--header-text);
`;

const ErrorMessage = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: red;
  height: ${(props) => props.error};
  transition: 300ms;
`;

export const InputText = ({
  label,
  type,
  placeholder,
  errorMessage,
  register,
  name,
  control,
  mwidth,
  value,
  required = true,
  readOnly = false,
  multiline = false,
  ...otherProps
}) => {
  const [showPassword] = useState(true);

  if (type === "email")
    return (
      <Container {...otherProps}>
        <StyledLabel>{label}</StyledLabel>
        <FormControl>
          <OutlinedInput
            type={showPassword ? "text" : "password"}
            size="small"
            sx={{ borderRadius: "8px" }}
            placeholder={placeholder}
            readOnly={readOnly}
            {...register}
            autoComplete="email"
          // endAdornment={
          //   <InputAdornment position="end">
          //     <IconButton
          //       aria-label="toggle password visibility"
          //       onClick={handleClickShowPassword}
          //       onMouseDown={handleMouseDownPassword}
          //       edge="end"
          //     >
          //       {showPassword ? <EyeIcon show /> : <EyeIcon />}
          //     </IconButton>
          //   </InputAdornment>
          // }
          />
          <FormHelperText error sx={{ height: "0" }}>
            {errorMessage && "*" + errorMessage}
          </FormHelperText>
        </FormControl>
      </Container>
    );
  else
    return (
      <Container mwidth={mwidth}>
        <StyledLabel>{label}</StyledLabel>
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              size="small"
              multiline={multiline}
              minRows={1}
              maxRows={5}
              inputProps={{ readOnly }}
              placeholder={value || placeholder}
            />
          )}
          rules={{ required }}
        />
        <ErrorMessage>
          {errorMessage === "required" ? "Campo obligatorio" : errorMessage}
        </ErrorMessage>
      </Container>
    );
};
